<input type="checkbox" id="matchRegExp" class="toolbarField" />
<label for="matchRegExp" class="toolbarLabel" data-l10n-id="pdfjs-find-regexp-checkbox-label"
  title="pass a regular expression"> Regular Expression
</label>